var _circle, _g, _circle2, _circle3, _circle4, _circle5, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCloudGraySm = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 152,
  height: 120,
  fill: "none",
  viewBox: "0 0 152 120",
  ref: ref
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 76,
  cy: 52,
  r: 52,
  fill: "var(--utility-gray-200, black)"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_dd_1182_1994)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "var(--utility-gray-50, black)",
  d: "M77.6 16c-10.773 0-20.302 5.323-26.101 13.483A25.7 25.7 0 0 0 45.6 28.8C31.462 28.8 20 40.261 20 54.4S31.462 80 45.6 80h64c12.371 0 22.4-10.029 22.4-22.4s-10.029-22.4-22.4-22.4q-1.32 0-2.598.149C102.098 23.968 90.78 16 77.6 16"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 45.6,
  cy: 54.4,
  r: 25.6,
  fill: "url(#a)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 77.6,
  cy: 48,
  r: 32,
  fill: "url(#b)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 109.6,
  cy: 57.6,
  r: 22.4,
  fill: "url(#c)"
}))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 21,
  cy: 19,
  r: 5,
  fill: "var(--utility-gray-100, black)"
})), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  cx: 18,
  cy: 109,
  r: 7,
  fill: "var(--utility-gray-100, black)"
})), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
  cx: 145,
  cy: 35,
  r: 7,
  fill: "var(--utility-gray-100, black)"
})), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
  cx: 134,
  cy: 8,
  r: 4,
  fill: "var(--utility-gray-100, black)"
})), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter1_b_1182_1994)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "var(--utility-gray-400, black)",
  d: "M52 86c0-13.255 10.745-24 24-24s24 10.745 24 24-10.745 24-24 24-24-10.745-24-24"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "var(--fg-white)",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "m85 95-3.5-3.5m2.5-6a8.5 8.5 0 1 1-17 0 8.5 8.5 0 0 1 17 0"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "a",
  x1: 25.943,
  x2: 71.2,
  y1: 37.486,
  y2: 80,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#D0D5DD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.351,
  stopColor: "var(--utility-gray-200, black)",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "b",
  x1: 53.029,
  x2: 109.6,
  y1: 26.857,
  y2: 80,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#D0D5DD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.351,
  stopColor: "var(--utility-gray-200, black)",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "c",
  x1: 92.4,
  x2: 132,
  y1: 42.8,
  y2: 80,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#D0D5DD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.351,
  stopColor: "var(--utility-gray-200, black)",
  stopOpacity: 0
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgCloudGraySm);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/CloudGraySm.2638b83bb5346ecc36abe139b931579d.svg";